import { render } from "./EnjoySongEdit.vue?vue&type=template&id=1341f334"
import script from "./EnjoySongEdit.vue?vue&type=script&lang=js"
export * from "./EnjoySongEdit.vue?vue&type=script&lang=js"
script.render = render

export default script